var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import AccountService from '../../api/AccountService';
import { Loading } from 'element-ui';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.total = 0;
        _this.listData = [];
        _this.total_point = 0;
        return _this;
    }
    default_1.prototype.created = function () {
        this.accountService = AccountService.getInstance();
        this.getList();
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        var timeout = setTimeout(function () {
            clearTimeout(timeout);
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    default_1.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.accountService
            .getPointLog(pager)
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data ? res.data : {};
            _this.total_point = DATA.total_point || 0;
            _this.listData = Array.isArray(DATA.data) ? DATA.data : [];
            _this.total = DATA.total || 0;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
